const initialState = {
  loading: false,
  balanceData: null,
  topUpData: null,
  polBalance: 0,
  estimatedTransactions: 0,
  error: null,
  balanceLoading: false,
  topUpLoading: false,
};

const gasFeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GAS_FEE_BALANCE_REQUEST":
      return {
        ...state,
        balanceLoading: true,
        error: null,
      };

    case "GAS_FEE_BALANCE_SUCCESS":
      return {
        ...state,
        balanceData: action.payload,
        polBalance: action.payload?.balance || 0,
        estimatedTransactions: action.payload?.estimatedTransactions || 0,
        error: null,
      };

    case "GAS_FEE_BALANCE_FAIL":
      return {
        ...state,
        error: action.payload,
      };

    case "GAS_FEE_BALANCE_REQUEST_END":
      return {
        ...state,
        balanceLoading: false,
      };

    case "TOP_UP_WALLET_REQUEST":
      return {
        ...state,
        topUpLoading: true,
        error: null,
      };

    case "TOP_UP_WALLET_SUCCESS":
      return {
        ...state,
        topUpData: action.payload,
        error: null,
      };

    case "TOP_UP_WALLET_FAIL":
      return {
        ...state,
        error: action.payload,
      };

    case "TOP_UP_WALLET_REQUEST_END":
      return {
        ...state,
        topUpLoading: false,
      };

    case "CLEAR_GAS_FEE_ERRORS":
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default gasFeeReducer;